import { NextRouter } from 'next/router';
import { IntlShape } from 'react-intl';
import { getLocalStorageEntry } from 'src/utils/webStorageUtils';
import { SOURCE_LANGUAGE } from 'src/utils/language/saveLastLanguagePair';
import { intlGetMessagesLocale } from 'src/utils/intl';
import { getBrowserLocale } from 'src/utils/browser';
import {
  CUSTOM_APP_LOCALES_MAP,
  DEFAULT_LOCALE,
  SOURCE_LANGUAGES_LOCALES_MAP,
  SUPPORTED_APP_LOCALES,
} from 'src/constants/locales.const';

export const getPreselectedSourceLanguage = (intl: IntlShape, router?: NextRouter): string => {
  const messagesLocale = intlGetMessagesLocale(intl.locale);
  // re-map the locale into app locale as we support more public locales that app locales
  const appLocale = SUPPORTED_APP_LOCALES.includes(messagesLocale)
    ? messagesLocale
    : CUSTOM_APP_LOCALES_MAP[messagesLocale];

  const slsForLocale = Object.keys(SOURCE_LANGUAGES_LOCALES_MAP).filter(
    sl => SOURCE_LANGUAGES_LOCALES_MAP[sl] === appLocale,
  );

  if (slsForLocale.length === 0) {
    // shouldn't happen, because we always have at least one source language for every supported intl locale
    return DEFAULT_LOCALE;
  }

  if (slsForLocale.length === 1) {
    return slsForLocale[0];
  }

  // we can have more than one source language for locale, e.g. for en
  // use other know info to determine which one is better to use

  const queryLang = router?.query?.lang;
  if (queryLang && slsForLocale.some(sl => sl === String(queryLang))) {
    return String(queryLang);
  }

  const storedSourceLanguage = getLocalStorageEntry(SOURCE_LANGUAGE);
  if (storedSourceLanguage && slsForLocale.includes(storedSourceLanguage)) {
    return storedSourceLanguage;
  }
  const browserLocale = getBrowserLocale()?.toLocaleLowerCase();
  if (browserLocale && slsForLocale.includes(browserLocale)) {
    return browserLocale;
  }

  return slsForLocale[0];
};
